import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "50",
  height: "50",
  viewBox: "0 0 15.794 14.102"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F16755",
  "fill-rule": "evenodd",
  d: "M7.9 11.85a.846.846 0 1 1 .846-.846.846.846 0 0 1-.846.846zm-.564-2.82h1.125V3.95H7.333zm8.36 3.913L8.6.406a.815.815 0 0 0-1.41 0L.1 12.939a.785.785 0 0 0 .705 1.164h14.183a.785.785 0 0 0 .705-1.164z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };